<template>
	<div class="container">
		<div class="status-list" style="display:flex;justify-content: space-between;align-items:center;width:100%;">
			<div style="flex:1;display:flex;">
				<div class="status-item" v-for="(v,k) in status_list" :key="`s`+k"
					:class="{active:current_status===v.value}" @click="change_status(v.value)">
					{{v.name}} ({{v.count}})
				</div>
			</div>
			<div class="search" style="right:35px;">
				<img src="../../assets/images/icon-search.png" alt="" class="icon-search">
				<input type="text" placeholder="Search design name" v-model="form_data.keyword" class="input" @keyup.enter="search">
			</div>
			<!-- <div style="width:25px;height:25px;">
				<img v-if="list_mode == 'list'" src="../../assets/images/icon-list-mode-1.png" @click="list_mode='img'"
					style="width:25px;height:25px;" />
				<img v-if="list_mode == 'img'" src="../../assets/images/icon-list-mode-2.png" @click="list_mode='list'"
					style="width:25px;height:25px;" />
			</div> -->
		</div>

		<template v-if="design_list.length>0">
			<template v-if="list_mode === 'img'">
				<div class="img-mode-list">
					<div class="item" v-for="(item,index) in design_list" :key="`img${index}`" @mouseenter="onMouseEnter(index)" @mouseleave="onMouseLeave" @click="go(item)">
						<div v-if="hoverIndex === index" class="img-hover">
							<div class="img-hover-container">
								<div v-if="[3,4].includes(item.status)" :class="['img-hover-tags',{'status-3':item.status == 3,'status-4':item.status == 4}]">{{item.status_name}}</div>
								<div class="img-hover-btns">
									<Poptip trigger="hover" placement="top-start" :transfer="false" popper-class="custom-popper">
										<template #content>
											<div>Delete</div>
										</template>
										<Button class="img-hover-btn-store" @click.stop="del(item.uuid)">
											<img src="../../assets/images/icon-delete-hover.png" />
										</Button>
									</Poptip>
									<Poptip trigger="hover" placement="top-end" :transfer="false" popper-class="custom-popper"> 
										<template #content>
											<div>Order</div>
										</template>
										<Button class="img-hover-btn-store" v-if="item.status === 4" @click.stop="checkout(item.uuid)">
											<img src="../../assets/images/icon-order-design-list.png" />
										</Button>
									</Poptip>
									<Poptip trigger="hover" placement="top-end" :transfer="false" popper-class="custom-popper">
										<template #content>
											<div>Publish</div>
										</template>
										<Button class="img-hover-btn-store" @click.stop="onsale(item.uuid)" v-if="item.status === 4">
											<img src="../../assets/images/icon-store-design-list.png" />
										</Button>
									</Poptip>
									<Poptip trigger="hover" placement="top-end" :transfer="false" popper-class="custom-popper"> 
										<template #content>
											<div>Copy to create new</div>
										</template>
										<Button class="img-hover-btn-store" @click.stop="copy(item.uuid)" >
											<img src="../../assets/images/icon-copy-design-list.png" />
										</Button>
									</Poptip>
								</div>
							</div>
						</div>
						<img :src="item.image | default_img"
							class="img-mode-pic" />
						<div class="img-text-container">
							<div class="title">{{item.name}}</div>
						</div>
						<div class="style-no">Style No: {{item.style_no}}</div>
						<div class="date-time">{{item.update_time | enDate}}</div>
					</div>
				</div>
			</template>
			<template v-if="list_mode === 'list'">
				<div class="list">
					<div class="item" v-for="(v, k) in design_list" :key="`d` + k" @click="go(v)">
						<div class="left">
							<img :src="v.image | default_img" alt="" class="image">
						</div>
						<div class="right">
							<div class="right-box">
							<div class="name-wrap">
								<div class="name">{{ v.name }}</div>
								<div class="status" :class="oc(v)">{{ v.status_name }}</div>
							</div>
							<div class="style_no"><span>Style No</span>：{{ v.style_no }}</div>
							<div class="category"><span>Category</span>：{{ v.product_category_name }}</div>
							<div class="step" v-if="v.status >= 3">
								Design Price: {{ v.factory_price }}元
							</div>
							<div class="desc"><span>Description</span>：{{ v.description }}</div>
							<div class="time">Created: {{ v.update_time }}</div>
							<div class="btn-group">
								<div class="btn btn-del" @click.stop="del(v.uuid)">Delete</div>
								<div class="btn btn-design" @click.stop="copy(v.uuid)">Copy to create new</div>
								<div class="btn btn-del" v-if="v.status === 4" @click.stop="onsale(v.uuid)">Publish</div>
								<div class="btn btn-design" v-if="v.status === 4" @click.stop="checkout(v.uuid)">Order</div>
							</div>
						</div>
						</div>
					</div>
				</div>
			</template>
		</template>
		<template v-else>
			<img src="../../assets/images/no-data.png" style="width:300px;display: block;margin:0 auto;" alt="">
		</template>

	</div>

</template>

<script>
	import axios from 'axios'
	import {
		Profile,
		DesignList,
		DesignCount,
		CopyDesignToDraft,
		DeleteDesign,
	} from "@/api/index.js"
	export default {
		name: 'WorkbenchMyTemplate',
		components: {
		},
		data() {
			return {
				form_data: {
					keyword: '',
					status: -1,
				},
				current_status: -1,
				status_list: {
					all: {name: 'ALL', value: -1, count: 0},
					factory_bargain: {name: 'To be confirmed', value: 3, count: 0},
					confirm_design: {name: 'Confirmed', value: 4, count: 0},
				},
				design_list: [],
				is_popup_show: false,
				current_design: {},
				list_mode:'img',
				hoverIndex:'',
				load_end:false
			};
		},
		watch: {
			current_status(newVal, oldVal) {
				this.form_data.status = newVal
				this.getDesignList()
			},
			// list_mode(newVal, oldVal){
			// 	this.design_list = [];
			// 	this.onLoadMore();
			// }
		},
		computed: {
			avatar() {
				return this.profile.avatar || require('@/assets/images/avatar.png')
			}
		},
		mounted() {
			axios.all([
				this.getProfile(),
				this.getDesignList()
			]).then(axios.spread(() => {

			}))
		},
		methods: {
			onLoadMore(){
				this.form_data.page++;
				if(!this.load_end){
					this.getDesignList();
				}else{
					this.$layer.msg('No more data');
				}
			},
			onMouseEnter(index,e){
				this.hoverIndex = index;
			},
			onMouseLeave(e){
				this.hoverIndex = '';
			},
			copy(uuid) {
				this.$DModal.confirm({
					content: 'Confirm to copy this design to draft?',
					okText:'Confirm',
                	cancelText:'Cancel',
					onOK: () => {
						CopyDesignToDraft({uuid}).then((response) => {
							this.$router.push({ name: "WorkBenchDesign", query: { uuid: response.data.uuid } })
						})
					}
				})
			},
			onsale(uuid) {
				this.$router.push({name: 'ProductEdit', query: {design_uuid: uuid}})
			},
			search() {
				this.getDesignList()
			},
			oc(v) {
				return [v.status_text]
			},
			change_status(s) {
				this.current_status = s
			},
			go(v) {
				this.checkout(v.uuid);
			},
			del(uuid) {
				this.$DModal.confirm({
					content: 'Confirm to delete this design?',
					okText:'Confirm',
                	cancelText:'Cancel',
					onOK: () => {
						DeleteDesign({uuid}).then(() => {
							this.$layer.msg(`Operation successful`)
						}).finally(() => {
							this.getDesignList()
						})
					}
				})
			},
			checkout(uuid) {
				this.$router.push({name: 'WorkBenchSummary', query: {uuid, from: 'design'}})
			},
			async getProfile() {
				return Profile().then(response => {
					return response
				})
			},
			async getDesignList() {
				this.design_list = [];
				return DesignList(this.form_data).then(response => {
					this.design_list = response.data;
					return DesignCount(this.form_data)
				}).then(response => {
					for(let code in response.data) {
						this.status_list[code].count = response.data[code]
					}
				})
			},
		},

	}
</script>

<style lang="scss" scoped>
	.container {
		padding:0 70px 0 30px;
		background: white;

		.status-list {
			position: relative;
			padding: 25px 0;
			display: flex;
			align-content: center;
			border-bottom:1px solid #e0e0e0;
			.status-item {
				margin: 0 14px;
				// width: 80px;
				height: 35px;
				line-height: 35px;
				font-size: 14px;
				text-align: center;
				cursor: pointer;
				padding:0 10px;
				color:#4d4d4d;
				font-weight: bold;
				position:relative;
				&.active {
					color:#000000;
					// border-bottom:2px solid #000000;
					&::after{
						content:'';
						position:absolute;
						bottom:-25px;
						left:0;
						right:0;
						height:2px;
						background:#000000;
					}
				}
				&:first-child {
					margin-left: 0;
				}
			}
			.search {
				position: absolute;
				top: 23px;
				right: 0;
				.icon-search {
					position: absolute;
					top: 15px;
					left: 20px;
					width: 20px;
					height: 20px;
				}
				.input {
					width: 260px;
					height: 50px;
					line-height: 50px;
					border-radius: 25px;
					padding-left: 50px;
					background: #F3F4F6;
					font-size: 14px;
					outline: none;
					border: none;
				}
			}
		}
		.img-mode-list {
			display: flex;
			align-items: flex-start;
			width: 100%;
			overflow-x: auto;
			flex-wrap: wrap;
			column-count:4;
			column-gap:20px;
			margin-top:30px;
			.item {
				position: relative;
				// display:block;
				// flex: 0 0 230px;
				width:290px;
				border-radius: 10px;
				// margin-right: 20px;
				margin-bottom: 30px;

				.img-hover {
					position: absolute;
					width: 100%;
					border-radius: 10px;
					height: 290px;
					background: rgba(0, 0, 0, 0.25);

					.img-hover-container {
						position: relative;
						width: 100%;
						height: 100%;

						.img-hover-tags {
							display: flex;
							align-items: center;
							justify-content: center;
							font-size: 12px;
							margin-top: 15px;
							margin-left: 15px;
							// border-top-right-radius: 10px;
							// border-bottom-right-radius: 10px;
							// background: #FC8C16;
							border-radius:3px;
							// max-width: 60px;
							width:fit-content;
							&.status-3{
								color: #fc8c16;
								border:1px solid #fc8c16;
								padding:4px;
							}
							&.status-4{
								color: #fa5c74;
								border:1px solid #fa5c74;
								padding:4px 12px;
							}
						}

						.img-hover-btns {
							display: flex;
							justify-content: flex-end;
							align-items: center;
							position: absolute;
							bottom: 20px;
							right: 0px;

							.img-hover-btn-store {
								border: none;
								margin-right: 5px;
								height:32px;
								width:32px;
								display:flex;
								justify-content:center;
								align-items:cneter;
								background:rgba(0,0,0,0.7);
								img{
									width:24px;
									height:24px;
								}

								&:hover{
									background:#4d49fc;
								}

								// &:nth-last-child(1){
								// 	background:#FA3D5A;
								// 	color:#ffffff;
								// }
							}

							.img-hover-btn-price {
								background: #FA3D5A;
								color: white;
								border: none;
								margin-right: 5px;
								height:35px;
							}

						}
					}
				}
			}

			.img-mode-pic {
				width: 100%;
				height: 290px;
				border-radius: 10px;
				border: 1px solid #EBEDF2;
				object-fit: cover;
			}

			.img-text-container {
				display: flex;
				justify-content: space-between;
				align-items: center;

				.title {
					font-weight: bold;
					font-size: 16px;
					flex:0 0 55%;
					overflow:hidden;
					text-overflow: ellipsis;
					white-space:nowrap;
					color:#000000;
				}

				.date-time {
					color: #888888;
					font-size: 12px;
					flex:0 0 45%;
					overflow:hidden;
					text-overflow: ellipsis;
					white-space:nowrap;
					text-align:right;
				}
			}

			.style-no {
				color: #666666;
				font-size: 12px;
				margin-bottom:6px;
			}
		}
		.list {
			padding: 10px 0 50px 0;
			display: flex;
			align-items: center;
			// column-gap:20px;
			// row-gap:20px;
			flex-wrap: wrap;
			box-sizing:border-box;
			gap:20px;
			.item {
				display: flex;
				flex-wrap: nowrap;
				// width: 750px;
				// flex:0 1 48%;
				flex:0 0 calc(50% - 10px);
				max-width:48%;
				height: 270px;
				// margin:0 20px 20px 0;
				background: #FFFFFF;
				border-radius: 10px 10px 10px 10px;
				border: 1px solid #EBEDF2;
				cursor: pointer;
				.left {
					width: 240px;
					// height: 240px;
					height:100%;
					flex-shrink: 0;
					.image {
						border:1px solid #ebedf2;
						width: 100%;
						height: 100%;
						object-fit: cover;
						border-radius: 10px 0 0 10px;
					}
				}
				.right {
					// padding: 0 20px;
					// width: 480px;
					flex:1;
					max-width:calc(100% - 240px);
					.right-box{
						padding:0 20px;

						.name-wrap{
							height: 53px;
							display: flex;
							align-items: center;
							justify-content: space-between;
							border-bottom: 1px solid #EBEDF2;
							.name {
								font-size: 18px;
								color: #333333;
								font-weight: bold;
							}
							.status {
								width: 70px;
								height: 25px;
								line-height: 25px;
								border-radius: 5px 0px 5px 0px;
								text-align: center;
								font-family: "Microsoft YaHei";
								&.draft {
									color: #30C6D0;
									border: 1px solid #30C6D0;
								}
								&.bargain {
									color: #FF9000;
									border: 1px solid #FF9000;
								}
								&.confirm_design {
									color: #E72C28;
									border: 1px solid #E72C28;
								}
							}
						}

						.style_no, .category, .desc {
							margin: 6px 0;
							color: #707070;
							font-size: 14px;
						}
						.desc {
							height: 40px;
							overflow-y: hidden;
						}

						span {
							color: #4D4D4D;
							font-size: 14px;
						}

						.time {
							margin: 5px 0;
							font-size: 12px;
							color: #808080;
							text-overflow:ellipsis;
							overflow:hidden;
							white-space:nowrap;
						}

						.btn-group {
							margin-top: 23px;
							display: flex;
							justify-content: flex-end;
							.btn {
								width: 100px;
								height: 35px;
								line-height: 35px;
								text-align: center;
								border-radius: 5px;
								font-size: 14px;
								margin: 0 5px;
								&.btn-del {
									border: 1px solid #D0D2D6;
									color: #68696A;
								}
								&.btn-design {
									background: #FA3D5A;
									color: white;
								}
							}
						}
					}
				}



				&:nth-child(2n) {
					margin-right: 0;
				}
			}
		}
	}

	::v-deep .popup-modal {
		h2 {
			padding: 10px 20px;
			color: #333333;
			font-size: 18px;
			font-weight: bold;
			border-bottom: 1px solid #F0F0F0;
		}

		.table {
			margin: 10px 0;
			display: flex;
			flex-wrap: nowrap;
			.item {
				flex: 1;
				.th {
					background: #F2F2F2;
				}
				.td {
					height: 55px;
					line-height: 55px;
					text-align: center;
					color: #191A1C;
					border: 1px solid #E3E3E3;
				}
			}

		}


		.btn-submit {
			margin: 40px auto;
			width: 110px;
			height: 40px;
			line-height: 40px;
			text-align: center;
			background: #FA3D5A;
			color: white;
			border-radius: 6px;
			cursor: pointer;
		}

	}

	::v-deep .custom-popper {
		.ivu-poptip-inner {
			background-color: rgba(0, 0, 0, 0.5) !important;
			border-radius: 4px;
			color:#ffffff;
		}
		
		
		.ivu-poptip-arrow {
			
			border-color: rgba(0, 0, 0, 0.5) transparent transparent transparent; /* top arrow */
		}

		.ivu-poptip-arrow::after {
			
			border-color: rgba(0, 0, 0, 0.1) transparent transparent transparent; /* top arrow */
		}
	}

	@media (min-width:1280px) and (max-width:1679px){
		.container .img-mode-list {
			column-count:4;
			column-gap:10px;
			.item {
				width:261px;
				border-radius: 10px;
				margin-bottom: 30px;

				.img-hover {
					height: 261px;
				}
			}

			.img-mode-pic {
				height: 261px;
			}
		}
	}

	@media (max-width:1279px){
		.container .img-mode-list {
			column-count:4;
			column-gap:10px;
			.item {
				width:222px;
				border-radius: 10px;
				margin-bottom: 30px;

				.img-hover {
					height: 222px;
				}
			}

			.img-mode-pic {
				height: 222px;
			}
		}
	}
</style>
